import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import PageBreadcrumb from 'components/common/PageBreadcrumb';
import ProcesosTopSection from 'components/modules/project-management/ProcesosTopSection';
import CobrosListTable, {
  cobrosListTableColumns
} from 'components/tables/CobrosListTable';
import { defaultBreadcrumbItems } from 'data/commonData';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useState, useEffect } from 'react';
import { useAuth } from 'providers/AuthProvider';
import { Cobro, cobroInicial } from 'data/project-management/Cobro';

const CobrosListView = () => {
  const [cobros, setcobros] = useState([]);
  const { user, loading, logout } = useAuth();
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:2000'; 

  useEffect(() => {
      if (!user?.iniciales) return;

      const fetchCobros = async () => {
        try {
          const response = await axios.get(
            `${apiUrl}/cobros/pendientes/usuario/${user.iniciales}`
          );
          setcobros(response.data); 
        } catch (error) {
          console.error('ha habido un error: ', error);
        }
      };

    fetchCobros();
    
    // 3. Le decimos a React: "Ejecuta esto una vez, y VUELVE a ejecutarlo 
    // ÚNICAMENTE si las iniciales del usuario cambian".
  }, [user?.iniciales, apiUrl]);

  const table = useAdvanceTable({
    data: cobros,
    columns: cobrosListTableColumns,
    pageSize: 180,
    pagination: true,
    sortable: true
  });

  return (
    <div>
      <AdvanceTableProvider {...table}>
        <div className="d-flex flex-wrap mb-4 gap-3 gap-sm-6 align-items-center">
          <h2 className="mb-0">
            <div className="me-3">Cobros Pendientes (Actores)</div>{' '}
            <div className="fw-normal text-body-tertiary"></div>
          </h2>
        </div>
        {/*         <ProcesosTopSection activeView="list" />
         */}{' '}
        <CobrosListTable />
      </AdvanceTableProvider>
    </div>
  );
};

export default CobrosListView;
